import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RecrewtSyncStatus, SyncRun } from './sync.model';

/**
 * Organizer-triggered, one-way Sync-to-RECREWT. Posts a source (anymatch) session's
 * recruiting exhibitors to the anymatch backend, which sends them (with the session's
 * study fields, branches and logos) into the RECREWT session stored on the session.
 * Manual only — the platform never syncs automatically on edit.
 */
@Injectable({ providedIn: 'root' })
export class SyncService {
  private http = inject(HttpClient);

  /** `targetSessionId` is used, and stored on the session, only while the session has no RECREWT session yet. */
  syncSessionToRecrewt(sessionId: string, targetSessionId?: string): Observable<SyncRun> {
    return this.http.post<SyncRun>(`${environment.apiUrl}/private/sync/recrewt`, {
      sessionId,
      targetSessionId,
    });
  }

  status(sessionId: string): Observable<RecrewtSyncStatus> {
    return this.http.get<RecrewtSyncStatus>(`${environment.apiUrl}/private/sync/recrewt/status`, {
      params: { sessionId },
    });
  }
}
